import { createClient } from '@supabase/supabase-js'

// En temel Supabase istemcisi
const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

// Supabase client - Basit ve öntanımlı depolama ile
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    // Cookie depolama yerine, Supabase'in varsayılan localStorage kullanımına dönüyoruz
    // çünkü OAuth işlemleri için localStorage daha uyumlu çalışıyor
  }
})

// Token almak için doğrudan Supabase'i kullanan metod
export const getSupabaseToken = async (): Promise<string | null> => {
  try {
    const { data } = await supabase.auth.getSession()
    return data.session?.access_token || null
  } catch {
    return null
  }
} 